import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { configURI } from '../../../shared/apiUrlConfig';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { UserFriendlyMsgs } from '../../app.user-msgs'
import { error } from 'protractor';
import { environment } from '../../../environments/environment';


@Injectable()
export class ParDueDiligenceService {
  load;
 //  url1 = configURI;
  // New Api's  
  url = environment.configURI;
  private addDocument = '/par/duediligence';
  private getListOfDocs = '/par/duediligence';
  private deleteDocumentByID = '/par/duediligence/document/';
  private updateDocumentByID = '/par/duediligence/document/'
  private listOfDocTypes = '/documents/GetDocumentTypesByCategory?Category=PARDUEDILIGENCE';
  private clientparDuediligencedocs = '/client/par/duediligence';

  //Old Api's
  // private documentsList = "/DocumentTypes/GetDocumentTypesByCategory?Category=PARDUEDILIGENCE";
  // private createDocUrl = '/parduediligence/createdocument';
  // private listOfDocDetails = "/parduediligence/getalldocs";
  // private documentbyID = '/parduediligence/getdocbyid?';
  // private updateDocUrl = '/parduediligence/updatedoc';
  // private deleteDocUrl = '/parduediligence/deletedoc?docid=';

  constructor(private httpClient: HttpClient, private userFriendlyMsgs: UserFriendlyMsgs) {
    this.load = new BehaviorSubject('initial');
  }

  // httpClientHeaderOptions = {
  //   headers: new HttpHeaders({
  //     'x-access-token': localStorage.getItem('Token'),
  //     'Cache-Control': 'no-cache',
  //     'Pragma': 'no-cache',
  //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
  //   })
  // };

  // To get list of document types
  listOfDocuments() {
      // this.httpClientHeaderOptions = {
      //   headers: new HttpHeaders({
      //     'x-access-token': localStorage.getItem('Token'),
      //     'Cache-Control': 'no-cache',
      //     'Pragma': 'no-cache',
      //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
      //   })
      // };

      //this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
      return this.httpClient.get(`${this.url}${this.listOfDocTypes}`).catch(this.userFriendlyMsgs.errorHandler);
  }

  // Create a document
  createDocument(body) {
    // this.httpClientHeaderOptions = {
    //   headers: new HttpHeaders({
    //     'x-access-token': localStorage.getItem('Token'),
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //   })
    // };
    //this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
    return this.httpClient.post(`${this.url}${this.addDocument}`, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  // on load documents list
  getDocDetails() {
    // this.httpClientHeaderOptions = {
    //   headers: new HttpHeaders({
    //     'x-access-token': localStorage.getItem('Token'),
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //   })
    // };
    //this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
    let role = parseInt(localStorage.getItem("RoleVal"))
    if(role === 8){
      return this.httpClient.get(`${this.url}${this.clientparDuediligencedocs}`).catch(this.userFriendlyMsgs.errorHandler);
    }else{
    return this.httpClient.get(`${this.url}${this.getListOfDocs}`).catch(this.userFriendlyMsgs.errorHandler);
    }
  }

  // Get document by ID
  // getDocumentByID(ID){
  //   return this.httpClient.get(`${this.url}${this.documentbyID}${ID}`, this.httpClientHeaderOptions);
  // }

  //Update a document
  updateDocument(ID, body) {
    // this.httpClientHeaderOptions = {
    //   headers: new HttpHeaders({
    //     // 'x-access-token': localStorage.getItem('Token'),
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //   })
    // };
    //this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
    return this.httpClient.put(`${this.url}${this.updateDocumentByID}${ID}`, body).catch(this.userFriendlyMsgs.errorHandler);
  }

  // Delete a document
  deleteDocument(ID) {
    // this.httpClientHeaderOptions = {
    //   headers: new HttpHeaders({
    //     // 'x-access-token': localStorage.getItem('Token'),
    //     'Cache-Control': 'no-cache',
    //     'Pragma': 'no-cache',
    //     'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    //   })
    // };
    //this.httpClientHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
    return this.httpClient.delete(`${this.url}${this.deleteDocumentByID}${ID}`).catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/par-due-diligence/par-due-diligence.service.ts